export interface ProgressBarProps {
  fraction: number;
  label: string;
}

/** Rink-length bar: a blue fill on an ice track. Clamps to 0..1 and names itself for assistive tech. */
export function ProgressBar({ fraction, label }: ProgressBarProps) {
  const percent = Math.round(Math.min(1, Math.max(0, fraction)) * 100);
  return (
    <div className="space-y-1.5">
      <div
        className="h-2 overflow-hidden rounded-full bg-ice-2"
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
      >
        <div
          className="h-full rounded-full bg-blue transition-[width] duration-[420ms] ease-rink"
          style={{ width: `${percent}%` }}
        />
      </div>
      <p className="text-micro text-ink-3">{label}</p>
    </div>
  );
}
